import { http, queryString } from 'utils'

import { SET_UTILIZATION, RESET_UTILIZATION } from 'vx/mutations'

const initialUtilzationState = () => ({
  dailyTotals: [],
  projectPercentageBreakdown: [],
  userSummaries: [],
  utilization: [],
  utilizationRates: [],
})

// Deceased state.
const state = {
  utilization: initialUtilzationState()
}

// Deceased state getters.
const getters = {}

// Deceased actions.
const actions = {

  getUtilizationData ({commit}, payload) {
    return http.get(`dashboards/utilization?${queryString(payload)}`)
      .then((response) => {
        commit(SET_UTILIZATION, response.data)

        return response
      })
  },
}

// Beneficiaries state mutations.
const mutations = {

  [SET_UTILIZATION] (state, utilization) {
    state.utilization = utilization
  },

  [RESET_UTILIZATION] (state, utilization) {
    state.utilization = initialUtilzationState()
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
